const kn = {
  nav: {
    home: "ಮುಖಪುಟ",
    salons: "ಸಲೂನ್‌ಗಳು",
    membership: "ಸದಸ್ಯತ್ವ",
    shop: "ಅಂಗಡಿ",
    academy: "ಅಕಾಡೆಮಿ",
    blog: "ಜರ್ನಲ್",
    login: "ಲಾಗಿನ್",
    logout: "ಲಾಗ್ ಔಟ್",
    dashboard: "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
    bookings: "ನನ್ನ ಬುಕಿಂಗ್‌ಗಳು",
    loyalty: "ಲಾಯಲ್ಟಿ",
    profile: "ಪ್ರೊಫೈಲ್",
    orders: "ನನ್ನ ಆರ್ಡರ್‌ಗಳು",
    chat: "ಸಂಭಾಷಣೆಗಳು",
    notifications: "ಅಧಿಸೂಚನೆಗಳು",
    partner: "ಪಾಲುದಾರ",
    admin: "ನಿರ್ವಾಹಕ",
    partner_panel: "ಪಾಲುದಾರ ಪ್ಯಾನೆಲ್",
    admin_panel: "ನಿರ್ವಾಹಕ ಪ್ಯಾನೆಲ್",
    login_register: "ಲಾಗಿನ್ / ನೋಂದಣಿ",
    skip_to_content: "ವಿಷಯಕ್ಕೆ ತೆರಳಿ",
    account_menu: "ಖಾತೆ ಮೆನು",
    primary_nav: "ಮುಖ್ಯ",
    mobile_nav: "ಮೊಬೈಲ್ ನ್ಯಾವಿಗೇಷನ್",
    ai_advisor: "AI ಸಲಹೆಗಾರ",
    cart: "ಶಾಪಿಂಗ್ ಕಾರ್ಟ್",
  },
  footer: {
    tagline: "ಭಾರತದ ಪ್ರೀಮಿಯಂ ಸಲೂನ್ ಬುಕಿಂಗ್ ವೇದಿಕೆ — ಐಷಾರಾಮಿ ಸೌಂದರ್ಯವನ್ನು ನಿಮ್ಮ ಬೆರಳ ತುದಿಗೆ ತರುತ್ತದೆ.",
    company: "ಕಂಪನಿ",
    about: "ನಮ್ಮ ಬಗ್ಗೆ",
    how_it_works: "ಹೇಗೆ ಕಾರ್ಯನಿರ್ವಹಿಸುತ್ತದೆ",
    partners: "ಪಾಲುದಾರರಿಗಾಗಿ",
    stylists: "ಸ್ಟೈಲಿಸ್ಟ್‌ಗಳಿಗಾಗಿ",
    careers: "ಉದ್ಯೋಗಾವಕಾಶಗಳು",
    contact: "ಸಂಪರ್ಕ",
    support: "ಬೆಂಬಲ",
    faq: "FAQ",
    help: "ಸಹಾಯ ಕೇಂದ್ರ",
    privacy: "ಗೌಪ್ಯತಾ ನೀತಿ",
    terms: "ಸೇವಾ ನಿಯಮಗಳು",
    refund: "ಮರುಪಾವತಿ ನೀತಿ",
    services: "ಸೇವೆಗಳು",
    salons: "ಸಲೂನ್‌ಗಳು",
    membership: "ಸದಸ್ಯತ್ವ",
    shop: "ಅಂಗಡಿ",
    academy: "ಅಕಾಡೆಮಿ",
    connect: "ಸಂಪರ್ಕಿಸಿ",
    newsletter_title: "ನಮ್ಮ ನ್ಯೂಸ್‌ಲೆಟರ್‌ಗೆ ಸೇರಿ",
    newsletter_sub: "ಸೌಂದರ್ಯ ಸಲಹೆಗಳು, ವಿಶೇಷ ಕೊಡುಗೆಗಳು, ಸ್ಪ್ಯಾಮ್ ಇಲ್ಲ.",
    newsletter_placeholder: "ನಿಮ್ಮ ಇಮೇಲ್",
    newsletter_cta: "ಚಂದಾದಾರರಾಗಿ",
    copyright: "© {{year}} Fayriza. ಎಲ್ಲ ಹಕ್ಕುಗಳನ್ನು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ.",
    made_in: "ಭಾರತದಲ್ಲಿ ತಯಾರಿಸಲಾಗಿದೆ",
  },
  home: {
    hero_eyebrow: "ಭಾರತದ ಪ್ರೀಮಿಯಂ ಸಲೂನ್ ಜಾಲ",
    hero_title: "ನಿಮ್ಮ ಪರಿಪೂರ್ಣ ಸಲೂನ್ ಅನುಭವವನ್ನು ಕಂಡುಕೊಳ್ಳಿ",
    hero_subtitle: "ನಿಮ್ಮ ಹತ್ತಿರದ ಉತ್ತಮ ಸಲೂನ್‌ಗಳಲ್ಲಿ ಅಪಾಯಿಂಟ್‌ಮೆಂಟ್ ಬುಕ್ ಮಾಡಿ — ಐಷಾರಾಮ, ಅನುಕೂಲ ಮತ್ತು ಕಾಳಜಿ.",
    search_placeholder: "ಸಲೂನ್, ಸೇವೆಗಳು ಅಥವಾ ಸ್ಟೈಲಿಸ್ಟ್‌ಗಳನ್ನು ಹುಡುಕಿ…",
    search_cta: "ಸಲೂನ್ ಹುಡುಕಿ",
    featured_salons: "ವಿಶೇಷ ಸಲೂನ್‌ಗಳು",
    browse_all: "ಎಲ್ಲವನ್ನು ನೋಡಿ",
    view_all: "ಎಲ್ಲವನ್ನು ವೀಕ್ಷಿಸಿ",
    categories_title: "ವಿಭಾಗಗಳನ್ನು ಅನ್ವೇಷಿಸಿ",
    categories_sub: "ಪ್ರತಿ ಸಂದರ್ಭಕ್ಕೂ ಉತ್ತಮ ಸೇವೆಗಳು",
    why_title: "Fayriza ಏಕೆ",
    why_sub: "ಪ್ರಾರಂಭದಿಂದ ಅಂತ್ಯದವರೆಗೆ ಪ್ರೀಮಿಯಂ ಅನುಭವ",
    why_1_title: "ಪರಿಶೀಲಿತ ಸಲೂನ್‌ಗಳು",
    why_1_body: "ಪ್ರತಿ ಪಾಲುದಾರ ಸಲೂನ್ ಅನ್ನು ಕೈಯಾರೆ ಆಯ್ಕೆ ಮಾಡಿ ಗುಣಮಟ್ಟ ಪರಿಶೀಲಿಸಲಾಗಿದೆ.",
    why_2_title: "ತಕ್ಷಣ ಬುಕಿಂಗ್",
    why_2_body: "ನೈಜ-ಸಮಯದ ಲಭ್ಯತೆ, ಕ್ಷಣಗಳಲ್ಲಿ ದೃಢೀಕರಿಸಲಾಗುತ್ತದೆ.",
    why_3_title: "ಸುರಕ್ಷಿತ ಪಾವತಿಗಳು",
    why_3_body: "Razorpay ಬೆಂಬಲಿತ, ಮರುಪಾವತಿ-ರಕ್ಷಿತ ವಹಿವಾಟುಗಳು.",
    why_4_title: "ಲಾಯಲ್ಟಿ ಮತ್ತು ಪುರಸ್ಕಾರಗಳು",
    why_4_body: "ಪ್ರತಿ ಭೇಟಿಯಲ್ಲೂ ಪಾಯಿಂಟ್‌ಗಳನ್ನು ಗಳಿಸಿ, ಪ್ರಯೋಜನಗಳಿಗೆ ಬಳಸಿ.",
    testimonials_title: "ನಮ್ಮ ಸಮುದಾಯದ ಮೆಚ್ಚಿನ",
    cta_title: "ಹೊಳೆಯಲು ಸಿದ್ಧರಾ?",
    cta_sub: "ಸಾವಿರಾರು Fayriza ಸದಸ್ಯರನ್ನು ಸೇರಿ.",
    cta_btn: "ಪ್ರಾರಂಭಿಸಿ",
  },
  salons: {
    title: "ಎಲ್ಲಾ ಸಲೂನ್‌ಗಳು",
    subtitle: "ನಿಮ್ಮ ಹತ್ತಿರದ ಪ್ರೀಮಿಯಂ ಪಾಲುದಾರ ಸಲೂನ್‌ಗಳನ್ನು ಬ್ರೌಸ್ ಮಾಡಿ",
    filter: "ಫಿಲ್ಟರ್",
    sort: "ವಿಂಗಡಿಸಿ",
    sort_relevance: "ಪ್ರಸ್ತುತತೆ",
    sort_rating: "ಅತ್ಯುತ್ತಮ ರೇಟಿಂಗ್",
    sort_price_asc: "ಬೆಲೆ: ಕಡಿಮೆಯಿಂದ ಹೆಚ್ಚು",
    sort_price_desc: "ಬೆಲೆ: ಹೆಚ್ಚಿನಿಂದ ಕಡಿಮೆ",
    sort_nearest: "ಹತ್ತಿರದ",
    search_placeholder: "ಹೆಸರು ಅಥವಾ ಪ್ರದೇಶದಿಂದ ಹುಡುಕಿ…",
    categories_all: "ಎಲ್ಲ",
    city_all: "ಎಲ್ಲಾ ನಗರಗಳು",
    price_range: "ಬೆಲೆ ಶ್ರೇಣಿ",
    open_now: "ಈಗ ತೆರೆದಿದೆ",
    no_results_title: "ನಿಮ್ಮ ಫಿಲ್ಟರ್‌ಗಳಿಗೆ ಯಾವುದೇ ಸಲೂನ್ ಹೊಂದಾಣಿಕೆಯಾಗಿಲ್ಲ",
    no_results_sub: "ಫಿಲ್ಟರ್ ತೆಗೆದು ಅಥವಾ ಬೇರೆ ಪ್ರದೇಶ ಹುಡುಕಿ ನೋಡಿ.",
    clear_filters: "ಫಿಲ್ಟರ್‌ಗಳನ್ನು ತೆರವುಗೊಳಿಸಿ",
    showing: "{{count}} ಸಲೂನ್‌ಗಳನ್ನು ತೋರಿಸಲಾಗುತ್ತಿದೆ",
    loading: "ಸಲೂನ್‌ಗಳನ್ನು ಲೋಡ್ ಮಾಡಲಾಗುತ್ತಿದೆ…",
    book_now: "ಈಗ ಬುಕ್ ಮಾಡಿ",
    from: "ಇಂದ",
    per_service: "ಪ್ರತಿ ಸೇವೆಗೆ",
    results: "ಫಲಿತಾಂಶಗಳು",
    filters_title: "ಫಿಲ್ಟರ್‌ಗಳು",
    reset_all: "ಎಲ್ಲವನ್ನೂ ಮರುಹೊಂದಿಸಿ",
    category: "ವರ್ಗ",
    min_rating: "ಕನಿಷ್ಠ ರೇಟಿಂಗ್",
    any_rating: "ಯಾವುದೇ ರೇಟಿಂಗ್",
    for_gender: "ಯಾರಿಗಾಗಿ",
    gender_women: "ಮಹಿಳೆಯರು",
    gender_men: "ಪುರುಷರು",
    gender_unisex: "ಎಲ್ಲರಿಗೂ",
    cat_bridal: "ವಧು",
    cat_spa: "ಸ್ಪಾ",
  },
  salon: {
    book_now: "ಈಗ ಬುಕ್ ಮಾಡಿ",
    message: "ಸಂದೇಶ",
    favourite: "ಮೆಚ್ಚಿನ",
    unfavourite: "ಮೆಚ್ಚಿನದಿಂದ ತೆಗೆಯಿರಿ",
    share: "ಹಂಚಿಕೊಳ್ಳಿ",
    directions: "ದಾರಿ",
    call: "ಕರೆ ಮಾಡಿ",
    services: "ಸೇವೆಗಳು",
    stylists: "ಸ್ಟೈಲಿಸ್ಟ್‌ಗಳು",
    reviews: "ವಿಮರ್ಶೆಗಳು",
    availability: "ಲಭ್ಯತೆ",
    gallery: "ಗ್ಯಾಲರಿ",
    about: "ಬಗ್ಗೆ",
    working_hours: "ಕಾರ್ಯ ಸಮಯ",
    amenities: "ಸೌಲಭ್ಯಗಳು",
    contact: "ಸಂಪರ್ಕ",
    overview: "ಅವಲೋಕನ",
    location: "ಸ್ಥಳ",
    reviews_count: "{{count}} ವಿಮರ್ಶೆಗಳು",
    rating_out_of: "5 ರಲ್ಲಿ {{rating}}",
    select_service: "ಬುಕ್ ಮಾಡಲು ಸೇವೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    duration: "ಅವಧಿ",
    minutes: "{{min}} ನಿಮಿಷ",
    open: "ತೆರೆದಿದೆ",
    closed: "ಮುಚ್ಚಿದೆ",
    closes_at: "{{time}} ಕ್ಕೆ ಮುಚ್ಚುತ್ತದೆ",
    opens_at: "{{time}} ಕ್ಕೆ ತೆರೆಯುತ್ತದೆ",
  },
  booking: {
    title: "ಅಪಾಯಿಂಟ್‌ಮೆಂಟ್ ಬುಕ್ ಮಾಡಿ",
    step_services: "ಸೇವೆಗಳು",
    step_stylist: "ಸ್ಟೈಲಿಸ್ಟ್",
    step_datetime: "ದಿನಾಂಕ ಮತ್ತು ಸಮಯ",
    step_review: "ವಿಮರ್ಶೆ",
    step_pay: "ಪಾವತಿ",
    select_services: "ಸೇವೆಗಳನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    select_stylist: "ಸ್ಟೈಲಿಸ್ಟ್ ಆಯ್ಕೆಮಾಡಿ",
    any_stylist: "ಯಾವುದೇ ಲಭ್ಯ ಸ್ಟೈಲಿಸ್ಟ್",
    select_date: "ದಿನಾಂಕ ಆಯ್ಕೆಮಾಡಿ",
    select_time: "ಸಮಯ ಆಯ್ಕೆಮಾಡಿ",
    no_slots: "ಈ ದಿನಾಂಕಕ್ಕೆ ಯಾವುದೇ ಸ್ಲಾಟ್‌ಗಳು ಲಭ್ಯವಿಲ್ಲ",
    try_other_date: "ಬೇರೆ ದಿನಾಂಕ ಪ್ರಯತ್ನಿಸಿ",
    confirm: "ಬುಕಿಂಗ್ ದೃಢೀಕರಿಸಿ",
    cancel: "ಬುಕಿಂಗ್ ರದ್ದುಮಾಡಿ",
    reschedule: "ಮರು ನಿಗದಿಮಾಡಿ",
    subtotal: "ಉಪಮೊತ್ತ",
    discount: "ರಿಯಾಯಿತಿ",
    tax: "ತೆರಿಗೆಗಳು ಮತ್ತು ಶುಲ್ಕಗಳು",
    total: "ಒಟ್ಟು",
    pay_now: "ಈಗ ಪಾವತಿಸಿ",
    pay_at_salon: "ಸಲೂನ್‌ನಲ್ಲಿ ಪಾವತಿಸಿ",
    use_wallet: "ವಾಲೆಟ್ ಬಳಸಿ",
    apply_offer: "ಆಫರ್ ಅನ್ವಯಿಸಿ",
    offer_placeholder: "ಕೋಡ್ ನಮೂದಿಸಿ",
    apply: "ಅನ್ವಯಿಸಿ",
    remove: "ತೆಗೆದುಹಾಕಿ",
    booking_confirmed: "ಬುಕಿಂಗ್ ದೃಢೀಕರಿಸಲಾಗಿದೆ!",
    booking_cancelled: "ಬುಕಿಂಗ್ ರದ್ದಾಗಿದೆ",
    booking_ref: "ಬುಕಿಂಗ್ ID",
    when: "ಯಾವಾಗ",
    where: "ಎಲ್ಲಿ",
    who: "ಜೊತೆ",
    notes: "ಸೂಚನೆ ಸೇರಿಸಿ (ಐಚ್ಛಿಕ)",
    notes_placeholder: "ಅಲರ್ಜಿಗಳು, ಆದ್ಯತೆಗಳು…",
    upcoming: "ಮುಂಬರುವ",
    past: "ಹಿಂದಿನ",
    cancelled: "ರದ್ದಾಗಿದೆ",
    view_details: "ವಿವರಗಳನ್ನು ನೋಡಿ",
    download_receipt: "ರಸೀದಿ ಡೌನ್‌ಲೋಡ್ ಮಾಡಿ",
    rate_visit: "ಈ ಭೇಟಿಯನ್ನು ರೇಟ್ ಮಾಡಿ",
  },
  auth: {
    login_title: "ಮತ್ತೆ ಸ್ವಾಗತ",
    login_sub: "Fayriza ಗೆ ಮುಂದುವರಿಯಲು ಸೈನ್ ಇನ್ ಮಾಡಿ",
    register_title: "ಖಾತೆ ರಚಿಸಿ",
    register_sub: "ಭಾರತದ ಪ್ರೀಮಿಯಂ ಸಲೂನ್ ಜಾಲಕ್ಕೆ ಸೇರಿ",
    email: "ಇಮೇಲ್",
    email_placeholder: "you@example.com",
    password: "ಪಾಸ್‌ವರ್ಡ್",
    password_placeholder: "ಕನಿಷ್ಠ 8 ಅಕ್ಷರಗಳು",
    phone: "ಫೋನ್ ಸಂಖ್ಯೆ",
    phone_placeholder: "10-ಅಂಕಿಯ ಮೊಬೈಲ್ ಸಂಖ್ಯೆ",
    name: "ಪೂರ್ಣ ಹೆಸರು",
    name_placeholder: "ನಿಮ್ಮ ಹೆಸರು",
    otp: "OTP ನಮೂದಿಸಿ",
    otp_placeholder: "6-ಅಂಕಿಯ ಕೋಡ್",
    send_otp: "OTP ಕಳುಹಿಸಿ",
    verify_otp: "ಪರಿಶೀಲಿಸಿ",
    resend_otp: "OTP ಮರುಕಳುಹಿಸಿ",
    resend_in: "{{s}}s ನಲ್ಲಿ ಮರುಕಳುಹಿಸಿ",
    login_cta: "ಸೈನ್ ಇನ್",
    register_cta: "ಖಾತೆ ರಚಿಸಿ",
    forgot_password: "ಪಾಸ್‌ವರ್ಡ್ ಮರೆತಿರಾ?",
    reset_password: "ಪಾಸ್‌ವರ್ಡ್ ಮರುಹೊಂದಿಸಿ",
    reset_sub: "ನಿಮ್ಮ ಇಮೇಲ್ ನಮೂದಿಸಿ, ನಾವು ಮರುಹೊಂದಿಕೆ ಲಿಂಕ್ ಕಳುಹಿಸುತ್ತೇವೆ",
    reset_sent: "ಮರುಹೊಂದಿಕೆ ಲಿಂಕ್ ನಿಮ್ಮ ಇಮೇಲ್‌ಗೆ ಕಳುಹಿಸಲಾಗಿದೆ",
    new_password: "ಹೊಸ ಪಾಸ್‌ವರ್ಡ್",
    confirm_password: "ಪಾಸ್‌ವರ್ಡ್ ದೃಢೀಕರಿಸಿ",
    social_login: "ಅಥವಾ ಇದರೊಂದಿಗೆ ಮುಂದುವರಿಯಿರಿ",
    google: "Google",
    facebook: "Facebook",
    apple: "Apple",
    verify_email: "ಇಮೇಲ್ ಪರಿಶೀಲಿಸಿ",
    verify_email_sub: "ನಾವು {{email}} ಗೆ ಪರಿಶೀಲನಾ ಲಿಂಕ್ ಕಳುಹಿಸಿದ್ದೇವೆ",
    resend_email: "ಪರಿಶೀಲನಾ ಇಮೇಲ್ ಮರುಕಳುಹಿಸಿ",
    accept_terms: "ನಾನು ನಿಯಮಗಳು ಮತ್ತು ಗೌಪ್ಯತಾ ನೀತಿಗೆ ಒಪ್ಪುತ್ತೇನೆ",
    switch_to_register: "ಖಾತೆ ಇಲ್ಲವೇ?",
    switch_to_register_cta: "ಸೈನ್ ಅಪ್",
    switch_to_login: "ಈಗಾಗಲೇ ಖಾತೆ ಇದೆಯೇ?",
    switch_to_login_cta: "ಸೈನ್ ಇನ್",
    remember_me: "ನನ್ನನ್ನು ನೆನಪಿಡಿ",
    phone_or_email: "ಫೋನ್ ಅಥವಾ ಇಮೇಲ್",
    use_phone: "ಬದಲಿಗೆ ಫೋನ್ ಬಳಸಿ",
    use_email: "ಬದಲಿಗೆ ಇಮೇಲ್ ಬಳಸಿ",
  },
  profile: {
    title: "ನನ್ನ ಪ್ರೊಫೈಲ್",
    edit_profile: "ಪ್ರೊಫೈಲ್ ಸಂಪಾದಿಸಿ",
    change_password: "ಪಾಸ್‌ವರ್ಡ್ ಬದಲಾಯಿಸಿ",
    avatar: "ಪ್ರೊಫೈಲ್ ಫೋಟೋ",
    upload_photo: "ಫೋಟೋ ಅಪ್‌ಲೋಡ್ ಮಾಡಿ",
    name: "ಪೂರ್ಣ ಹೆಸರು",
    phone: "ಫೋನ್ ಸಂಖ್ಯೆ",
    email: "ಇಮೇಲ್",
    dob: "ಹುಟ್ಟಿದ ದಿನಾಂಕ",
    gender: "ಲಿಂಗ",
    gender_male: "ಪುರುಷ",
    gender_female: "ಮಹಿಳೆ",
    gender_other: "ಇತರ",
    address: "ವಿಳಾಸ",
    city: "ನಗರ",
    pincode: "ಪಿನ್‌ಕೋಡ್",
    save: "ಬದಲಾವಣೆಗಳನ್ನು ಉಳಿಸಿ",
    saved: "ಪ್ರೊಫೈಲ್ ನವೀಕರಿಸಲಾಗಿದೆ",
    current_password: "ಪ್ರಸ್ತುತ ಪಾಸ್‌ವರ್ಡ್",
    current_password_placeholder: "ಪ್ರಸ್ತುತ ಪಾಸ್‌ವರ್ಡ್ ನಮೂದಿಸಿ",
    new_password: "ಹೊಸ ಪಾಸ್‌ವರ್ಡ್",
    new_password_placeholder: "ಕನಿಷ್ಠ 8 ಅಕ್ಷರಗಳು",
    password_changed: "ಪಾಸ್‌ವರ್ಡ್ ಯಶಸ್ವಿಯಾಗಿ ಬದಲಾಯಿಸಲಾಗಿದೆ",
  },
  dashboard: {
    title: "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
    welcome: "ಮತ್ತೆ ಸ್ವಾಗತ, {{name}}",
    upcoming_bookings: "ಮುಂಬರುವ ಬುಕಿಂಗ್‌ಗಳು",
    no_upcoming: "ಯಾವುದೇ ಮುಂಬರುವ ಅಪಾಯಿಂಟ್‌ಮೆಂಟ್‌ಗಳಿಲ್ಲ",
    book_a_salon: "ಸಲೂನ್ ಬುಕ್ ಮಾಡಿ",
    favourites: "ಮೆಚ್ಚಿನ ಸಲೂನ್‌ಗಳು",
    no_favourites: "ನೀವು ಇನ್ನೂ ಯಾವುದೇ ಸಲೂನ್‌ಗಳನ್ನು ಮೆಚ್ಚಿನಕ್ಕೆ ಸೇರಿಸಿಲ್ಲ",
    loyalty_points: "ಲಾಯಲ್ಟಿ ಪಾಯಿಂಟ್‌ಗಳು",
    wallet_balance: "ವಾಲೆಟ್ ಬಾಕಿ",
    recent_activity: "ಇತ್ತೀಚಿನ ಚಟುವಟಿಕೆ",
    quick_actions: "ತ್ವರಿತ ಕ್ರಮಗಳು",
    view_all: "ಎಲ್ಲವನ್ನು ವೀಕ್ಷಿಸಿ",
    manage_membership: "ಸದಸ್ಯತ್ವ ನಿರ್ವಹಿಸಿ",
    top_up_wallet: "ವಾಲೆಟ್ ಟಾಪ್ ಅಪ್ ಮಾಡಿ",
    refer_friend: "ಸ್ನೇಹಿತರಿಗೆ ಉಲ್ಲೇಖಿಸಿ",
  },
  common: {
    loading: "ಲೋಡ್ ಆಗುತ್ತಿದೆ…",
    error: "ಏನೋ ತಪ್ಪಾಗಿದೆ",
    retry: "ಮರುಪ್ರಯತ್ನಿಸಿ",
    no_results: "ಯಾವುದೇ ಫಲಿತಾಂಶ ಕಂಡುಬಂದಿಲ್ಲ",
    search: "ಹುಡುಕಿ",
    filter: "ಫಿಲ್ಟರ್",
    sort: "ವಿಂಗಡಿಸಿ",
    view_all: "ಎಲ್ಲವನ್ನು ವೀಕ್ಷಿಸಿ",
    see_more: "ಇನ್ನಷ್ಟು ನೋಡಿ",
    see_less: "ಕಡಿಮೆ ನೋಡಿ",
    back: "ಹಿಂದೆ",
    next: "ಮುಂದೆ",
    previous: "ಹಿಂದಿನ",
    submit: "ಸಲ್ಲಿಸಿ",
    cancel: "ರದ್ದುಮಾಡಿ",
    delete: "ಅಳಿಸಿ",
    edit: "ಸಂಪಾದಿಸಿ",
    save: "ಉಳಿಸಿ",
    close: "ಮುಚ್ಚಿ",
    confirm: "ದೃಢೀಕರಿಸಿ",
    continue: "ಮುಂದುವರಿಸಿ",
    yes: "ಹೌದು",
    no: "ಇಲ್ಲ",
    skip: "ಬಿಟ್ಟುಬಿಡಿ",
    optional: "ಐಚ್ಛಿಕ",
    required: "ಕಡ್ಡಾಯ",
    from: "ಇಂದ",
    per: "ಪ್ರತಿ",
    to: "ಗೆ",
    and: "ಮತ್ತು",
    or: "ಅಥವಾ",
    learn_more: "ಇನ್ನಷ್ಟು ತಿಳಿಯಿರಿ",
    coming_soon: "ಶೀಘ್ರದಲ್ಲೇ ಬರಲಿದೆ",
    currency: "₹",
    minutes_short: "ನಿಮಿ",
    hours_short: "ಗಂ",
    km: "ಕಿಮೀ",
    away: "ದೂರ",
    stars: "ನಕ್ಷತ್ರಗಳು",
  },
  loyalty: {
    title: "Fayriza ಲಾಯಲ್ಟಿ",
    subtitle: "ಪ್ರತಿ ಭೇಟಿಯಲ್ಲೂ ಪಾಯಿಂಟ್‌ಗಳನ್ನು ಗಳಿಸಿ, ಪುರಸ್ಕಾರಗಳಿಗೆ ಬಳಸಿ",
    points: "ಪಾಯಿಂಟ್‌ಗಳು",
    available_points: "ಲಭ್ಯ ಪಾಯಿಂಟ್‌ಗಳು",
    total_earned: "ಒಟ್ಟು ಗಳಿಸಲಾಗಿದೆ",
    total_redeemed: "ಒಟ್ಟು ಬಳಸಲಾಗಿದೆ",
    redeem: "ಬಳಸಿ",
    history: "ಪಾಯಿಂಟ್‌ಗಳ ಇತಿಹಾಸ",
    rewards: "ಪುರಸ್ಕಾರಗಳು",
    tier: "ಶ್ರೇಣಿ",
    how_it_works: "ಹೇಗೆ ಕಾರ್ಯನಿರ್ವಹಿಸುತ್ತದೆ",
    earn_title: "ಗಳಿಸಿ",
    earn_body: "ಪ್ರತಿ ₹10 ಖರ್ಚಿಗೆ 1 ಪಾಯಿಂಟ್. Gold ಗೆ 2×, Platinum ಗೆ 3×.",
    redeem_title: "ಬಳಸಿ",
    redeem_body: "ವಾಲೆಟ್ ಕ್ರೆಡಿಟ್, ಉಚಿತ ಸೇವೆಗಳು ಅಥವಾ ಪಾಲುದಾರ ಪ್ರಯೋಜನಗಳಿಗೆ ಪಾಯಿಂಟ್‌ಗಳನ್ನು ಬಳಸಿ.",
    empty_history: "ಇನ್ನೂ ಯಾವುದೇ ಪಾಯಿಂಟ್ ಚಟುವಟಿಕೆ ಇಲ್ಲ",
    empty_rewards: "ಸದ್ಯಕ್ಕೆ ಯಾವುದೇ ಪುರಸ್ಕಾರಗಳು ಲಭ್ಯವಿಲ್ಲ",
  },
  wallet: {
    title: "Fayriza ವಾಲೆಟ್",
    subtitle: "ಒಮ್ಮೆ ಟಾಪ್ ಅಪ್ ಮಾಡಿ, ಸರಾಗವಾಗಿ ಬುಕ್ ಮಾಡಿ",
    balance: "ಬಾಕಿ",
    available: "ಲಭ್ಯ",
    topup: "ಟಾಪ್ ಅಪ್",
    topup_cta: "ಹಣ ಸೇರಿಸಿ",
    topup_amount: "ಮೊತ್ತ",
    history: "ವಹಿವಾಟು ಇತಿಹಾಸ",
    empty_history: "ಇನ್ನೂ ಯಾವುದೇ ವಹಿವಾಟುಗಳಿಲ್ಲ",
    credit: "ಜಮಾ",
    debit: "ಡೆಬಿಟ್",
    refund: "ಮರುಪಾವತಿ",
  },
  membership: {
    eyebrow: "ವಿಶೇಷ ಪ್ರವೇಶ",
    hero_title: "Fayriza ಸದಸ್ಯತ್ವ ಯೋಜನೆಗಳು",
    hero_sub: "ಭಾರತದಾದ್ಯಂತ 500+ ಪ್ರೀಮಿಯಂ ಸಲೂನ್‌ಗಳಲ್ಲಿ ವಿಶೇಷ ರಿಯಾಯಿತಿಗಳು, ಆದ್ಯತೆಯ ಬುಕಿಂಗ್ ಮತ್ತು ಐಷಾರಾಮಿ ಪ್ರಯೋಜನಗಳನ್ನು ಅನ್ಲಾಕ್ ಮಾಡಿ.",
    plans: "ಸದಸ್ಯತ್ವ ಯೋಜನೆಗಳು",
    subscribe: "ಚಂದಾದಾರರಾಗಿ",
    cancel: "ಸದಸ್ಯತ್ವ ರದ್ದುಮಾಡಿ",
    current: "ಪ್ರಸ್ತುತ ಯೋಜನೆ",
    gold: "Gold",
    silver: "Silver",
    platinum: "Platinum",
    per_year: "/ವರ್ಷ",
    per_month_approx: "≈ ₹{{amount}}/ತಿಂಗಳು",
    cancel_anytime: "ಯಾವಾಗ ಬೇಕಾದರೂ ರದ್ದುಮಾಡಿ",
    choose_title: "ನಿಮ್ಮ ಯೋಜನೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    choose_sub: "ಎಲ್ಲಾ ಯೋಜನೆಗಳು ವಾರ್ಷಿಕವಾಗಿ ಬಿಲ್ ಮಾಡಲಾಗುತ್ತದೆ. ಯೋಜನೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ ಮತ್ತು ತಕ್ಷಣ ಸಕ್ರಿಯಗೊಳಿಸಲು ದೃಢೀಕರಿಸಿ.",
    most_popular: "ಅತ್ಯಂತ ಜನಪ್ರಿಯ",
    get_plan: "{{plan}} ಪಡೆಯಿರಿ",
    selected_proceed: "ಆಯ್ಕೆಮಾಡಲಾಗಿದೆ — ಪಾವತಿಸಲು ಮುಂದುವರಿಯಿರಿ →",
    processing: "ಪ್ರಕ್ರಿಯೆಗೊಳಿಸಲಾಗುತ್ತಿದೆ…",
    current_plan_label: "✓ ಪ್ರಸ್ತುತ ಯೋಜನೆ",
    welcome_back: "ಮತ್ತೆ ಸ್ವಾಗತ, {{name}}!",
    member_label: "Fayriza {{tier}} ಸದಸ್ಯ",
    expires_in: "{{days}} ದಿನಗಳಲ್ಲಿ ಅವಧಿ ಮುಗಿಯುತ್ತದೆ",
    renews_on: "{{date}} ರಂದು ನವೀಕರಿಸಲಾಗುತ್ತದೆ",
    your_discount: "ನಿಮ್ಮ ರಿಯಾಯಿತಿ",
    off_all: "ಎಲ್ಲಾ ಸೇವೆಗಳ ಮೇಲೆ ರಿಯಾಯಿತಿ",
    expiring_warn: "ನಿಮ್ಮ ಸದಸ್ಯತ್ವ ಶೀಘ್ರದಲ್ಲೇ ಕೊನೆಗೊಳ್ಳುತ್ತದೆ. ರಿಯಾಯಿತಿಗಳನ್ನು ಉಳಿಸಿಕೊಳ್ಳಲು ಈಗಲೇ ನವೀಕರಿಸಿ.",
    feature_comparison: "ಸಂಪೂರ್ಣ ವೈಶಿಷ್ಟ್ಯ ಹೋಲಿಕೆ",
    feature: "ವೈಶಿಷ್ಟ್ಯ",
    benefits_500: "500+ ಪಾಲುದಾರ ಸಲೂನ್‌ಗಳು",
    benefits_instant: "ತಕ್ಷಣ ಸಕ್ರಿಯಗೊಳಿಸುವಿಕೆ",
    benefits_cancel: "ಯಾವಾಗ ಬೇಕಾದರೂ ರದ್ದುಮಾಡಿ",
    benefits_refund: "7-ದಿನದ ಹಣ ಮರುಪಾವತಿ",
    faq_title: "ಪದೇ ಪದೇ ಕೇಳಲಾಗುವ ಪ್ರಶ್ನೆಗಳು",
    faq_cancel_q: "ನಾನು ನನ್ನ ಸದಸ್ಯತ್ವವನ್ನು ರದ್ದುಪಡಿಸಬಹುದೇ?",
    faq_cancel_a: "ಹೌದು. ನಿಮ್ಮ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್‌ನಿಂದ ಯಾವಾಗ ಬೇಕಾದರೂ ರದ್ದುಪಡಿಸಬಹುದು. ನಿಮ್ಮ ಬಿಲ್ಲಿಂಗ್ ಅವಧಿಯ ಕೊನೆಯವರೆಗೂ ನಿಮ್ಮ ಪ್ರಯೋಜನಗಳು ಮುಂದುವರಿಯುತ್ತವೆ.",
    faq_all_salons_q: "ರಿಯಾಯಿತಿ ಎಲ್ಲಾ ಸಲೂನ್‌ಗಳಿಗೂ ಅನ್ವಯಿಸುತ್ತದೆಯೇ?",
    faq_all_salons_a: "ಹೌದು — ಭಾರತದಾದ್ಯಂತ 500+ ಪರಿಶೀಲಿತ Fayriza ಪಾಲುದಾರ ಸಲೂನ್‌ಗಳಲ್ಲಿ ರಿಯಾಯಿತಿ ಸ್ವಯಂಚಾಲಿತವಾಗಿ ಅನ್ವಯಿಸುತ್ತದೆ.",
    faq_refund_q: "7-ದಿನದ ಹಣ ಮರುಪಾವತಿ ಖಾತರಿ ಎಂದರೇನು?",
    faq_refund_a: "ಸಕ್ರಿಯಗೊಳಿಸಿದ 7 ದಿನಗಳಲ್ಲಿ ನೀವು ತೃಪ್ತರಾಗದಿದ್ದರೆ, ನಿಮ್ಮ ಸದಸ್ಯತ್ವ ಶುಲ್ಕವನ್ನು ಪೂರ್ಣವಾಗಿ ಮರುಪಾವತಿಸುತ್ತೇವೆ — ಯಾವುದೇ ಪ್ರಶ್ನೆಗಳಿಲ್ಲದೆ.",
    faq_upgrade_q: "ನಾನು ನನ್ನ ಯೋಜನೆಯನ್ನು ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡಬಹುದೇ?",
    faq_upgrade_a: "ಹೌದು. ನೀವು ಯಾವಾಗ ಬೇಕಾದರೂ ಅಪ್‌ಗ್ರೇಡ್ ಮಾಡಬಹುದು. ಉಳಿದ ಅವಧಿಗೆ ಅನುಗುಣವಾದ ವ್ಯತ್ಯಾಸವನ್ನು ನಿಮಗೆ ಶುಲ್ಕ ವಿಧಿಸಲಾಗುತ್ತದೆ.",
    activated: "🎉 Fayriza {{plan}} ಸಕ್ರಿಯಗೊಳಿಸಲಾಗಿದೆ!",
    subscribe_failed: "ಚಂದಾದಾರಿಕೆ ವಿಫಲವಾಗಿದೆ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
  },
  shop: {
    eyebrow: "Fayriza ಅಂಗಡಿ",
    hero_title: "ಪ್ರೀಮಿಯಂ ಸೌಂದರ್ಯ ಮತ್ತು ಗ್ರೂಮಿಂಗ್ ಉತ್ಪನ್ನಗಳು",
    hero_sub: "ನಿಮ್ಮ ಬಾಗಿಲಿಗೆ ತಲುಪಿಸಲಾದ ವೃತ್ತಿಪರ ದರ್ಜೆಯ ಅಗತ್ಯ ವಸ್ತುಗಳು.",
    search_placeholder: "ಉತ್ಪನ್ನಗಳನ್ನು ಹುಡುಕಿ…",
    categories: "ವಿಭಾಗಗಳು",
    all_products: "ಎಲ್ಲಾ ಉತ್ಪನ್ನಗಳು",
    add_to_cart: "ಕಾರ್ಟ್‌ಗೆ ಸೇರಿಸಿ",
    added: "ಸೇರಿಸಲಾಗಿದೆ ✓",
    out_of_stock: "ಸ್ಟಾಕ್ ಮುಗಿದಿದೆ",
    checkout: "ಚೆಕ್‌ಔಟ್",
    cart: "ಕಾರ್ಟ್",
    cart_empty: "ನಿಮ್ಮ ಕಾರ್ಟ್ ಖಾಲಿಯಾಗಿದೆ",
    cart_empty_sub: "ಅದನ್ನು ತುಂಬಲು ಶಾಪಿಂಗ್ ಪ್ರಾರಂಭಿಸಿ",
    products: "ಉತ್ಪನ್ನಗಳು",
    orders: "ನನ್ನ ಆರ್ಡರ್‌ಗಳು",
    no_orders: "ಇನ್ನೂ ಯಾವುದೇ ಆರ್ಡರ್‌ಗಳಿಲ್ಲ",
    order_ref: "ಆರ್ಡರ್ ID",
    order_status: "ಸ್ಥಿತಿ",
    order_placed: "ಇರಿಸಲಾಗಿದೆ",
    order_shipped: "ಕಳುಹಿಸಲಾಗಿದೆ",
    order_delivered: "ತಲುಪಿಸಲಾಗಿದೆ",
    order_cancelled: "ರದ್ದಾಗಿದೆ",
    qty: "ಪ್ರಮಾಣ",
    remove: "ತೆಗೆದುಹಾಕಿ",
    subtotal: "ಉಪಮೊತ್ತ",
    shipping: "ಶಿಪ್ಪಿಂಗ್",
    tax: "ತೆರಿಗೆ",
    total: "ಒಟ್ಟು",
    proceed_checkout: "ಚೆಕ್‌ಔಟ್‌ಗೆ ಮುಂದುವರಿಯಿರಿ",
    shipping_address: "ಶಿಪ್ಪಿಂಗ್ ವಿಳಾಸ",
    place_order: "ಆರ್ಡರ್ ಇರಿಸಿ",
    continue_shopping: "ಶಾಪಿಂಗ್ ಮುಂದುವರಿಸಿ",
    product_details: "ಉತ್ಪನ್ನ ವಿವರಗಳು",
    description: "ವಿವರಣೆ",
    specifications: "ವಿಶೇಷಣಗಳು",
    you_may_like: "ನಿಮಗೆ ಇದು ಇಷ್ಟವಾಗಬಹುದು",
    related: "ಸಂಬಂಧಿತ ಉತ್ಪನ್ನಗಳು",
  },
  academy: {
    eyebrow: "Fayriza ಅಕಾಡೆಮಿ",
    hero_title: "ಭಾರತದ ಅತ್ಯುತ್ತಮ ಸ್ಟೈಲಿಸ್ಟ್‌ಗಳಿಂದ ಕಲಿಯಿರಿ",
    hero_sub: "ಪ್ರಮಾಣೀಕೃತ ಪರಿಣಿತರಿಂದ ಕಲಿಸಲಾಗುವ ವೃತ್ತಿಪರ ಸೌಂದರ್ಯ ಮತ್ತು ಗ್ರೂಮಿಂಗ್ ಕೋರ್ಸ್‌ಗಳು. ನಿಮ್ಮ ವೇಗದಲ್ಲಿ ಕಲಿಯಿರಿ, ಪ್ರಮಾಣಪತ್ರಗಳನ್ನು ಗಳಿಸಿ ಮತ್ತು ನಿಮ್ಮ ವೃತ್ತಿಜೀವನವನ್ನು ಪ್ರಾರಂಭಿಸಿ.",
    search_placeholder: "ಕೋರ್ಸ್‌ಗಳು ಅಥವಾ ಬೋಧಕರನ್ನು ಹುಡುಕಿ…",
    stats_courses: "ಪರಿಣಿತ ಕೋರ್ಸ್‌ಗಳು",
    stats_students: "ನೋಂದಾಯಿತ ವಿದ್ಯಾರ್ಥಿಗಳು",
    stats_rating: "ಸರಾಸರಿ ರೇಟಿಂಗ್",
    stats_certificate: "ಪ್ರಮಾಣಪತ್ರ ಸೇರಿದೆ",
    all: "ಎಲ್ಲಾ ಕೋರ್ಸ್‌ಗಳು",
    makeup: "ಮೇಕಪ್",
    hair: "ಕೂದಲು",
    skin: "ಚರ್ಮ",
    nails: "ಉಗುರುಗಳು",
    grooming: "ಗ್ರೂಮಿಂಗ್",
    courses: "ಕೋರ್ಸ್‌ಗಳು",
    course: "ಕೋರ್ಸ್",
    enroll: "ಈಗ ನೋಂದಾಯಿಸಿ",
    enrolled: "ನೋಂದಾಯಿಸಲಾಗಿದೆ",
    modules: "ಮಾಡ್ಯೂಲ್‌ಗಳು",
    instructor: "ಬೋಧಕ",
    duration: "ಅವಧಿ",
    level: "ಮಟ್ಟ",
    level_beginner: "ಆರಂಭಿಕ",
    level_intermediate: "ಮಧ್ಯಮ",
    level_advanced: "ಮುಂದುವರಿದ",
    certificate: "ಪ್ರಮಾಣಪತ್ರ",
    no_courses: "ನಿಮ್ಮ ಫಿಲ್ಟರ್‌ಗಳಿಗೆ ಯಾವುದೇ ಕೋರ್ಸ್‌ಗಳು ಹೊಂದಾಣಿಕೆಯಾಗಿಲ್ಲ",
    my_enrollments: "ನನ್ನ ಕೋರ್ಸ್‌ಗಳು",
    continue_learning: "ಕಲಿಕೆ ಮುಂದುವರಿಸಿ",
    completed: "ಪೂರ್ಣಗೊಂಡಿದೆ",
  },
  notifications: {
    title: "ಅಧಿಸೂಚನೆಗಳು",
    empty: "ನೀವು ಎಲ್ಲವನ್ನೂ ನೋಡಿದ್ದೀರಿ",
    empty_sub: "ಸದ್ಯಕ್ಕೆ ಯಾವುದೇ ಹೊಸ ಅಧಿಸೂಚನೆಗಳಿಲ್ಲ",
    mark_all_read: "ಎಲ್ಲವನ್ನೂ ಓದಿದಂತೆ ಗುರುತಿಸಿ",
    just_now: "ಈಗಷ್ಟೇ",
    minutes_ago: "{{n}}ನಿಮಿ ಹಿಂದೆ",
    hours_ago: "{{n}}ಗಂ ಹಿಂದೆ",
    days_ago: "{{n}}ದಿ ಹಿಂದೆ",
  },
  ai: {
    title: "Fayriza AI ಸಲಹೆಗಾರ",
    subtitle: "AI ಚಾಲಿತ, ವೈಯಕ್ತಿಕಗೊಳಿಸಿದ ಸೌಂದರ್ಯ ಶಿಫಾರಸುಗಳು.",
    placeholder: "ಚರ್ಮ, ಕೂದಲು, ಮೇಕಪ್ ಬಗ್ಗೆ ಏನಾದರೂ ಕೇಳಿ…",
    send: "ಕಳುಹಿಸಿ",
    examples_title: "ಕೇಳಲು ಪ್ರಯತ್ನಿಸಿ",
    ex_1: "ನನ್ನ ಮುಖದ ಆಕಾರಕ್ಕೆ ಉತ್ತಮ ಹೇರ್‌ಕಟ್?",
    ex_2: "ಎಣ್ಣೆಯುಕ್ತ ಚರ್ಮಕ್ಕೆ ಸ್ಕಿನ್‌ಕೇರ್ ದಿನಚರಿ",
    ex_3: "2026 ರ ವಧು ಮೇಕಪ್ ಟ್ರೆಂಡ್‌ಗಳು",
    thinking: "ಆಲೋಚಿಸುತ್ತಿದೆ…",
    disclaimer: "ಸಲಹೆಗಳು ಮಾಹಿತಿಗಾಗಿ. ವೈದ್ಯಕೀಯ ಸಮಸ್ಯೆಗಳಿಗೆ ವೃತ್ತಿಪರರನ್ನು ಸಂಪರ್ಕಿಸಿ.",
  },
  marketing: {
    about: {
      eyebrow: "ನಮ್ಮ ಕಥೆ",
      title: "ಸೌಂದರ್ಯ, ಪುನರ್ಕಲ್ಪಿತ",
      sub: "Fayriza ಒಂದು ಸರಳ ಕಲ್ಪನೆಯಿಂದ ಜನಿಸಿತು — ಭಾರತವು ತನ್ನ ಕಲೆಯಷ್ಟೇ ಪರಿಷ್ಕೃತ ಸಲೂನ್ ಬುಕಿಂಗ್ ಅನುಭವವನ್ನು ಅರ್ಹತೆ ಹೊಂದಿದೆ.",
      mission_title: "ನಮ್ಮ ಮಿಷನ್",
      mission_body: "ಲಕ್ಷಾಂತರ ಸೌಂದರ್ಯ ಉತ್ಸಾಹಿಗಳನ್ನು ಭಾರತದ ಅತ್ಯುತ್ತಮ ಸಲೂನ್‌ಗಳೊಂದಿಗೆ ಸರಾಗ, ವಿಶ್ವಾಸಾರ್ಹ ಮತ್ತು ಐಷಾರಾಮಿ ವೇದಿಕೆಯ ಮೂಲಕ ಸಂಪರ್ಕಿಸುವುದು.",
      vision_title: "ನಮ್ಮ ದೃಷ್ಟಿ",
      vision_body: "ಎಲ್ಲರಿಗೂ ಗುಣಮಟ್ಟದ ಸೌಂದರ್ಯ ಮತ್ತು ಸ್ವಾಸ್ಥ್ಯ ಸೇವೆಗಳು ಅವರ ಬೆರಳ ತುದಿಯಲ್ಲಿ ಲಭ್ಯವಿರುವ ಜಗತ್ತು.",
      values_title: "ನಮ್ಮ ಮೌಲ್ಯಗಳು",
      value_1_title: "ಗುಣಮಟ್ಟ ಮೊದಲು",
      value_1_body: "ಪ್ರತಿ ಪಾಲುದಾರ ಸಲೂನ್ ಪರಿಶೀಲಿತ ಮತ್ತು ನಮ್ಮ ಪ್ರೀಮಿಯಂ ಮಾನದಂಡಗಳಿಗೆ ಅನುಗುಣವಾಗಿದೆ.",
      value_2_title: "ಗ್ರಾಹಕ ಕೇಂದ್ರಿತ",
      value_2_body: "ನಿಮ್ಮ ಅನುಭವವೇ ನಮ್ಮ ಉತ್ತರ ನಕ್ಷತ್ರ — ಬುಕಿಂಗ್‌ನಿಂದ ನಂತರದ ಕಾಳಜಿಯವರೆಗೆ.",
      value_3_title: "ಪಾಲುದಾರರನ್ನು ಸಶಕ್ತಗೊಳಿಸುವುದು",
      value_3_body: "ನಮ್ಮ ಸಲೂನ್‌ಗಳು ಮತ್ತು ಸ್ಟೈಲಿಸ್ಟ್‌ಗಳು ಬೆಳೆದಾಗ ನಾವೂ ಬೆಳೆಯುತ್ತೇವೆ.",
      cta_title: "ಕಥೆಯ ಭಾಗವಾಗಿ",
      cta_sub: "ಇಂದೇ Fayriza ಸಮುದಾಯಕ್ಕೆ ಸೇರಿ.",
    },
    how_it_works: {
      eyebrow: "ಹೇಗೆ ಕಾರ್ಯನಿರ್ವಹಿಸುತ್ತದೆ",
      title: "ಮೂರು ಹಂತಗಳಲ್ಲಿ ಬುಕ್ ಮಾಡಿ",
      sub: "ಊಹಾಪೋಹವಿಲ್ಲದ ಪ್ರೀಮಿಯಂ ಸೌಂದರ್ಯ.",
      step_1_title: "ಅನ್ವೇಷಿಸಿ",
      step_1_body: "ನಿಮ್ಮ ಹತ್ತಿರದ ಪರಿಶೀಲಿತ ಸಲೂನ್‌ಗಳು, ಸೇವೆಗಳು ಮತ್ತು ಸ್ಟೈಲಿಸ್ಟ್‌ಗಳನ್ನು ಬ್ರೌಸ್ ಮಾಡಿ.",
      step_2_title: "ಬುಕ್ ಮಾಡಿ",
      step_2_body: "ನಿಮಗೆ ಅನುಕೂಲಕರ ಸಮಯವನ್ನು ಆಯ್ಕೆಮಾಡಿ — ತಕ್ಷಣ ದೃಢೀಕರಿಸಲಾಗುತ್ತದೆ.",
      step_3_title: "ಆನಂದಿಸಿ",
      step_3_body: "ಸೇವೆ ಪಡೆಯಿರಿ. ನಿಮ್ಮ ಭೇಟಿಯನ್ನು ರೇಟ್ ಮಾಡಿ. ಪುರಸ್ಕಾರಗಳನ್ನು ಗಳಿಸಿ.",
      faq_title: "ತ್ವರಿತ ಪ್ರಶ್ನೆಗಳು",
    },
    partners: {
      eyebrow: "ಸಲೂನ್ ಮಾಲೀಕರಿಗಾಗಿ",
      title: "Fayriza ಜೊತೆ ಬೆಳೆಯಿರಿ",
      sub: "ಹೊಸ ಗ್ರಾಹಕರನ್ನು ತಲುಪಿ, ಖಾಲಿ ಆಸನಗಳನ್ನು ತುಂಬಿ ಮತ್ತು ಆಧುನಿಕ ಸಲೂನ್ ನಡೆಸಿ.",
      benefit_1_title: "ಹೆಚ್ಚು ಗ್ರಾಹಕರು",
      benefit_1_body: "ಭಾರತದ ಅತಿದೊಡ್ಡ ಪ್ರೀಮಿಯಂ ಸೌಂದರ್ಯ ಪ್ರೇಕ್ಷಕರನ್ನು ಪ್ರವೇಶಿಸಿ.",
      benefit_2_title: "ಸ್ಮಾರ್ಟ್ ಬುಕಿಂಗ್",
      benefit_2_body: "ಒಂದೇ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್‌ನಿಂದ ವೇಳಾಪಟ್ಟಿ, ಸಿಬ್ಬಂದಿ ಮತ್ತು ಸೇವೆಗಳನ್ನು ನಿರ್ವಹಿಸಿ.",
      benefit_3_title: "ತಕ್ಷಣ ಪಾವತಿಗಳು",
      benefit_3_body: "ಸುರಕ್ಷಿತ, ವೇಗದ ಪಾವತಿಗಳು — ಕೈಯಾರೆ ಬೆನ್ನತ್ತುವ ಅಗತ್ಯವಿಲ್ಲ.",
      cta: "ಪಾಲುದಾರರಾಗಿ",
    },
    stylists: {
      eyebrow: "ಸ್ಟೈಲಿಸ್ಟ್‌ಗಳಿಗಾಗಿ",
      title: "ನಿಮ್ಮ ಗ್ರಾಹಕ ನೆಲೆಯನ್ನು ನಿರ್ಮಿಸಿ",
      sub: "ನಿಮ್ಮ ಕೆಲಸವನ್ನು ಪ್ರದರ್ಶಿಸಿ, ಗುರುತಿಸಲ್ಪಡಿ ಮತ್ತು ನಿಮ್ಮ ವೃತ್ತಿಜೀವನವನ್ನು ಬೆಳೆಸಿಕೊಳ್ಳಿ.",
      cta: "ಸ್ಟೈಲಿಸ್ಟ್ ಆಗಿ ಅರ್ಜಿ ಸಲ್ಲಿಸಿ",
    },
    careers: {
      eyebrow: "ಉದ್ಯೋಗಾವಕಾಶಗಳು",
      title: "ಸೌಂದರ್ಯದ ಭವಿಷ್ಯವನ್ನು ರೂಪಿಸಿ",
      sub: "ನಾವು ದೊಡ್ಡದನ್ನು ನಿರ್ಮಿಸುತ್ತಿರುವ ಸಣ್ಣ ತಂಡ. ಸೇರಲು ಬಯಸುತ್ತೀರಾ?",
      openings_title: "ತೆರೆದ ಹುದ್ದೆಗಳು",
      no_openings: "ಸದ್ಯಕ್ಕೆ ಯಾವುದೇ ಹುದ್ದೆಗಳು ತೆರೆದಿಲ್ಲ. careers@fayriza.com ಗೆ ಒಂದು ಸಂದೇಶ ಕಳುಹಿಸಿ.",
    },
    contact: {
      eyebrow: "ಸಂಪರ್ಕಿಸಿ",
      title: "ನಿಮ್ಮಿಂದ ಕೇಳಲು ನಾವು ಇಷ್ಟಪಡುತ್ತೇವೆ",
      sub: "ಪ್ರಶ್ನೆಗಳು, ಪ್ರತಿಕ್ರಿಯೆ ಅಥವಾ ಪಾಲುದಾರಿಕೆ ಆಲೋಚನೆಗಳು — ನಾವು ಎಲ್ಲಕ್ಕೂ ಕಿವಿಗೊಡುತ್ತೇವೆ.",
      name: "ನಿಮ್ಮ ಹೆಸರು",
      email: "ನಿಮ್ಮ ಇಮೇಲ್",
      message: "ಸಂದೇಶ",
      send: "ಸಂದೇಶ ಕಳುಹಿಸಿ",
      sent: "ಧನ್ಯವಾದಗಳು — ನಾವು 24 ಗಂಟೆಗಳಲ್ಲಿ ಮರಳಿ ಸಂಪರ್ಕಿಸುತ್ತೇವೆ.",
      support_email: "ಬೆಂಬಲ",
      partners_email: "ಪಾಲುದಾರರು",
      media_email: "ಮಾಧ್ಯಮ",
    },
    faq: {
      eyebrow: "ಸಹಾಯ",
      title: "ಪದೇ ಪದೇ ಕೇಳಲಾಗುವ ಪ್ರಶ್ನೆಗಳು",
      sub: "ಸಾಮಾನ್ಯ ಪ್ರಶ್ನೆಗಳಿಗೆ ತ್ವರಿತ ಉತ್ತರಗಳು.",
    },
    legal: {
      privacy_title: "ಗೌಪ್ಯತಾ ನೀತಿ",
      terms_title: "ಸೇವಾ ನಿಯಮಗಳು",
      refund_title: "ಮರುಪಾವತಿ ನೀತಿ",
      last_updated: "ಕೊನೆಯ ಬಾರಿ ನವೀಕರಿಸಲಾಗಿದೆ {{date}}",
    },
  },
  errors: {
    network: "ನೆಟ್‌ವರ್ಕ್ ದೋಷ — ನಿಮ್ಮ ಸಂಪರ್ಕವನ್ನು ಪರಿಶೀಲಿಸಿ",
    unauthorised: "ಮುಂದುವರಿಯಲು ದಯವಿಟ್ಟು ಸೈನ್ ಇನ್ ಮಾಡಿ",
    forbidden: "ಇದಕ್ಕೆ ನಿಮಗೆ ಪ್ರವೇಶವಿಲ್ಲ",
    not_found: "ನೀವು ಹುಡುಕುತ್ತಿರುವುದನ್ನು ನಾವು ಕಂಡುಹಿಡಿಯಲಾಗಲಿಲ್ಲ",
    server: "ಸರ್ವರ್ ದೋಷ — ದಯವಿಟ್ಟು ನಂತರ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ",
    validation: "ದಯವಿಟ್ಟು ಹೈಲೈಟ್ ಮಾಡಿದ ಕ್ಷೇತ್ರಗಳನ್ನು ಪರಿಶೀಲಿಸಿ",
    generic: "ಏನೋ ತಪ್ಪಾಗಿದೆ",
    page_not_found_title: "ಪುಟ ಕಂಡುಬಂದಿಲ್ಲ",
    page_not_found_sub: "ನೀವು ಹುಡುಕುತ್ತಿರುವ ಪುಟವು ಸ್ಥಳಾಂತರಗೊಂಡಿದೆ ಅಥವಾ ಇನ್ನು ಮುಂದೆ ಅಸ್ತಿತ್ವದಲ್ಲಿಲ್ಲ.",
    go_home: "ಮುಖಪುಟಕ್ಕೆ ಹೋಗಿ",
  },
};

export default kn;
